import {CtModelRouteData} from "@ctsolution/ct-framework";

export const UserRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("user");
